import { useState } from 'react';
import { Checkbox, MenuItem } from '@mui/material';
import CustomSelect from '../../../../components/common/SelectField';
import ObservationInput from './ObservationInput';
import { TableInput } from '../../../../components/common';

interface IProps {
  moduleData: any;
  tabValue: number;
  isView: boolean;
}
const TBody = ({ isView, moduleData, tabValue }: IProps) => {
  const [render, setRender] = useState(false);
  console.log(moduleData);
  return (
    <tbody>
      {moduleData.setups[tabValue] &&
        moduleData.setups[tabValue].setup_list &&
        moduleData.setups[tabValue].setup_list.map(
          (spec: any, index: number) => (
            <tr key={index + 'specs'}>
              <td>{index + 1}</td>
              <td
                style={{
                  width: '150px',
                  minWidth: '150px',
                }}
              >
                {spec.parameter}
              </td>
              <td
                style={{
                  width: '150px',
                  minWidth: '150px',
                }}
              >
                {spec.specification}
              </td>
              <td
                style={{
                  width: '150px',
                  minWidth: '150px',
                }}
              >
                {' '}
                {spec.methods}
              </td>
              {Array.from({ length: 5 }, (_, obsIndex) => (
                <ObservationInput
                  {...{ spec, setRender, isView, obsIndex }}
                  obsNumber={0}
                  checkType={spec.appearance}
                />
              ))}
              <td style={{ textTransform: 'uppercase', minWidth: '100px' }}>
                {spec.appearance === 'check3' ? (
                  isView ? (
                    spec.check_0_results
                  ) : (
                    <CustomSelect
                      name="dropdown"
                      value={spec.check_0_results || ''}
                      onChange={(e) => {
                        spec.check_0_results = e.target.value;
                        setRender((prev) => !prev);
                      }}
                      sx={{
                        textAlign: 'center',
                      }}
                    >
                      <MenuItem value="">NONE</MenuItem>
                      <MenuItem value="ok">OK</MenuItem>
                      <MenuItem value="ng">NG</MenuItem>
                    </CustomSelect>
                  )
                ) : (
                  spec.check_0_results
                )}
              </td>
              {Array.from({ length: 5 }, (_, obsIndex) => (
                <ObservationInput
                  {...{ spec, setRender, isView, obsIndex }}
                  obsNumber={1}
                  checkType={spec.appearance}
                />
              ))}
              <td style={{ textTransform: 'uppercase', minWidth: '100px' }}>
                {spec.appearance === 'check3' ? (
                  isView ? (
                    spec.check_1_results
                  ) : (
                    <CustomSelect
                      name="dropdown"
                      value={spec.check_1_results || ''}
                      onChange={(e) => {
                        spec.check_1_results = e.target.value;
                        setRender((prev) => !prev);
                      }}
                      sx={{
                        textAlign: 'center',
                      }}
                    >
                      <MenuItem value="">NONE</MenuItem>
                      <MenuItem value="ok">OK</MenuItem>
                      <MenuItem value="ng">NG</MenuItem>
                    </CustomSelect>
                  )
                ) : (
                  spec.check_1_results
                )}
              </td>
              <td
                style={{
                  width: '150px',
                  minWidth: '150px',
                }}
              >
                <TableInput
                  isView={isView}
                  name="scrap_qty"
                  type="number"
                  value={spec.scrap_qty}
                  onChange={(e) => {
                    spec.scrap_qty = e.target.value;
                    setRender((prev) => !prev);
                  }}
                />
              </td>
              <th
                style={{
                  textTransform: 'uppercase',
                  width: '150px',
                  minWidth: '150px',
                }}
                colSpan={isView ? 2 : 1}
              >
                <TableInput
                  isView={isView}
                  name="remarks"
                  type="text"
                  value={spec.remarks}
                  onChange={(e) => {
                    spec.remarks = e.target.value;
                    setRender((prev) => !prev);
                  }}
                />
              </th>
              {!isView && (
                <td style={{ minWidth: '120px', width: '120px' }}>
                  <Checkbox
                    name="changeCheckbox"
                    checked={spec.appearance === 'check3'}
                    onChange={() => {
                      if (spec.prev_appearance) {
                        spec.appearance = spec.prev_appearance;
                        spec.prev_appearance = null;
                      } else {
                        spec.prev_appearance = spec.appearance;
                        spec.appearance = 'check3';
                      }
                      setRender((prev) => !prev);
                    }}
                    style={{ color: '#064a29' }}
                  />
                </td>
              )}
            </tr>
          )
        )}
    </tbody>
  );
};

export default TBody;
